import { env } from './env'
import { defaultTheme, greenTheme, blueTheme, orangeTheme, redTheme, vividOrangeTheme, lightBlueTheme } from '@totalsoft/rocket-ui'
import whiteTheme from 'themes/whiteTheme'

const getTheme = () => {
  switch (env.REACT_APP_THEME) {
    case 'green':
      return greenTheme
    case 'blue':
      return blueTheme
    case 'orange':
      return orangeTheme
    case 'red':
      return redTheme
    case 'vividOrange':
      return vividOrangeTheme
    case 'lightBlue':
      return lightBlueTheme
    case 'white':
      return whiteTheme
    default:
      return defaultTheme
  }
}

export default getTheme
